import axios, { AxiosRequestConfig, Method } from 'axios'
import { MedconnectDevicesConfig, MedconnectDeviceValue } from '@/constants/medconnect-devices-types'

const MEDCONNECT_DEVICES_API_ROUTE = 'http://localhost:4001/api/main/'

async function requestToConnector<T>(method: Method, route: string, data: any): Promise<T> {
  // axios request to api
  var options: AxiosRequestConfig = {
    method: method,
    headers: {
      'Content-Type': 'application/json',
    },
  }

  if (method.toUpperCase() === 'POST' || method.toUpperCase() === 'PUT' || method.toUpperCase() === 'PATCH') {
    options = {
      ...options,
      data: data,
    }
  }
  try {
    const resp = await axios(`${MEDCONNECT_DEVICES_API_ROUTE}${route}`, options)
    return resp.data
  } catch (error) {
    console.error(error)
    return {} as T
  }
}

export async function createDevice(device: MedconnectDeviceValue): Promise<MedconnectDevicesConfig> {
  return await requestToConnector<MedconnectDevicesConfig>('POST', 'device', device)
}

export async function deleteDevice(deviceId: string): Promise<MedconnectDevicesConfig> {
  return await requestToConnector<MedconnectDevicesConfig>('DELETE', `device/${deviceId}`, {})
}

export async function restartDevice(deviceId: string): Promise<MedconnectDevicesConfig> {
  return await requestToConnector<MedconnectDevicesConfig>('GET', `device/${deviceId}/restart`, {})
}

export async function getConfig(): Promise<MedconnectDevicesConfig> {
  return await requestToConnector<MedconnectDevicesConfig>('GET', 'config', null)
}

export type SchillerPatient = {
  id: string
  name: string
  lastname: string
  birthdate: string
  gender: string
  height: string
  weight: string
}

export enum ExaminationTypes {
  RestingECG = 'EKG01',
  StressECG = 'ERGO01',
  Spirometry = 'LUFU00',
  ErgoSpirometry = 'ERGO05',
  RestingRhythm = 'EKG02',
  LatePotentialECG = 'EKG03',
  HolterLongTermECG = 'EKG04',
  /** more to be added */
}
export type EcgDTO = {
  patient: SchillerPatient
  type?: ExaminationTypes
}

export async function launchECG(data: EcgDTO): Promise<boolean> {
  return await requestToConnector<boolean>('POST', 'ecg', data)
}

export type SpirometryDTO = {
  patient: SchillerPatient
  protocol?: 'HL7' | 'EXCHANGE'
}

export async function launchSpirometry(data: SpirometryDTO): Promise<{ success: boolean; message: string }> {
  return await requestToConnector<{ success: boolean; message: string }>('POST', 'spirometry', data)
}
